import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CustomTextLinkComponent } from '@tran-monorepo/frontend/components';
import { ContentSectionComponent } from '../content-section/content-section.component';

@Component({
    selector: 'tran-link-section',
    imports: [TranslatePipe, ContentSectionComponent, CustomTextLinkComponent],
    templateUrl: './link-section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkSectionComponent {
    public readonly backgroundImage = input<string>();
    public readonly titleKey = input<string>();
    public readonly links = input<{ label: string; url: string; ariaLabel: string; isExternal: boolean }[]>([]);
}
